// To mark the passed HTML as trusted so that Angulars DOM sanitizer doesn't strip.
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtml implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@NgModule({
  declarations: [SafeHtml],
  imports: [],
  exports: [SafeHtml]
})
export class SafeHtmlModule { }



// WEBPACK FOOTER //
// ./src/app/services/safeHtml.ts